// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardFooter,
  Media,
  Table,
  Container,
  Row,
  Modal,
  ModalHeader, 
  ModalBody, 
  ModalFooter,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input
} from "reactstrap";
import { useState, useEffect} from "react";
import { toast } from 'react-toastify'


// core components

const Reports = () => {
  
  const API_URL = process.env.REACT_APP_API_URL;
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (status) {
      toast.warn(status);
      setStatus(null);
    }
  }, [status])

  const handleExportAnexo1 = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setStatus(null);
      const token = localStorage.getItem('@ProsperBI:pbiToken');
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: 'paineis',
          params: {
            action: "export_report",
            pbi_token: token,
            report_type: "anexo1"
          }
        })
      })

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        window.open(url);          
      }
    }
    catch (error) {
      console.error(error);
      setStatus('Erro ao gerar o relatório.');
    }
    finally {
      setLoading(false);
    }
  }
    

  const hoje = new Date();

  const [formPeriodo, setFormPeriodo] = useState({
    ano: hoje.getFullYear().toString(),
    mes: String(hoje.getMonth() + 1)
  });

  const handlePeriodoChange = (e) => {
    const { name, value } = e.target;
    setFormPeriodo(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const [modalRelatorio1, setModalRelatorio1] = useState(false);
  const toggleModalRelatorio1 = () => setModalRelatorio1(!modalRelatorio1);

  const closeModelRelatorio1 = () => {
    setLoading(false);
    toggleModalRelatorio1();
  }

  const handleExportReuniaoDG = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setStatus(null);
      const token = localStorage.getItem('@ProsperBI:pbiToken');
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: 'paineis',
          params: {
            action: "export_report",
            pbi_token: token,
            report_type: "reuniao_dg",
            ano: Number(formPeriodo.ano),
            mes_num: Number(formPeriodo.mes)
          }
        })
      })

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        window.open(url);          
      }

      closeModelRelatorio1();
    }
    catch (error) {
      console.error(error);
      setStatus('Erro ao gerar o relatório.');
    }
    finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h3 className="mb-0">RELATÓRIOS</h3>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">TÍTULO</th>
                      <th scope="col">DESCRIÇÃO</th>
                      <th scope="col">AÇÃO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">
                        <Media className="align-items-center">
                          <a
                            className="avatar rounded-circle mr-3"
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          >
                            <img
                              alt="..."
                              src={require("../assets/img/theme/report1.png")}
                            />
                          </a>
                          <Media>
                            <span className="mb-0 text-sm">
                              Apresentação - Reunião de Diretoria
                            </span>
                          </Media>
                        </Media>
                      </th>
                      <td>Relatório contendo a apresentação da reunião de diretoria mensal.</td>
                      <td>
                        <Button
                          color="primary"
                          href="#p1"
                          onClick={toggleModalRelatorio1}
                          size="sm"
                          disabled={loading}
                        >
                          Gerar Relatório
                        </Button>
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">
                        <Media className="align-items-center">
                          <a
                            className="avatar rounded-circle mr-3"
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                          >
                            <img
                              alt="..."
                              src={require("../assets/img/theme/report2.png")}
                            />
                          </a>
                          <Media>
                            <span className="mb-0 text-sm">
                              Relatório - Disponibilidade Financeira
                            </span>
                          </Media>
                        </Media>
                      </th>
                      <td>Relatório contendo o anexo da disponibilidade financeira.</td>
                      <td>
                        <Button
                          color="primary"
                          href="#p1"
                          onClick={(e) => handleExportAnexo1(e)}
                          size="sm"
                          disabled={loading}
                        >
                          Gerar Relatório
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                </Table>
                {loading && (
                  <CardFooter className="py-4 text-center">
                    <span className="mb-0 text-sm text-primary fw-bold">
                      Gerando o relatório, aguarde...
                    </span>                  
                  </CardFooter>
                )}
              </Card>
            </div>
          </Row>
        </Container>
      </div>

      <Modal isOpen={modalRelatorio1} toggle={toggleModalRelatorio1}>
        <Form method="post" onSubmit={handleExportReuniaoDG}>
          <ModalHeader toggle={toggleModalRelatorio1}>DADOS DO RELATÓRIO</ModalHeader>
          <ModalBody>          
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-calendar-grid-58" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="select"
                    name="ano"
                    value={formPeriodo.ano}
                    onChange={handlePeriodoChange}
                  >
                    <option value="">Selecione o Ano</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                  </Input>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-time-alarm" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="select"
                    name="mes"
                    value={formPeriodo.mes}
                    onChange={handlePeriodoChange}
                  >
                    <option value="">Selecione o Mês</option>
                    <option value="1">Janeiro</option>
                    <option value="2">Fevereiro</option>
                    <option value="3">Março</option>
                    <option value="4">Abril</option>
                    <option value="5">Maio</option>
                    <option value="6">Junho</option>
                    <option value="7">Julho</option>
                    <option value="8">Agosto</option>
                    <option value="9">Setembro</option>
                    <option value="10">Outubro</option>
                    <option value="11">Novembro</option>
                    <option value="12">Dezembro</option>
                  </Input>
                </InputGroup>
              </FormGroup> 
              {loading && (
                <div className="py-4 text-center">
                  <span className="mb-0 text-sm text-primary fw-bold">
                    Gerando o relatório, aguarde...
                  </span>                  
                </div>
              )}
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              Gerar Relatório
            </Button>
            <Button color="secondary" onClick={closeModelRelatorio1}>
              Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

    </>
  );
};

export default Reports;
